// @TODO set timeout when submitting form
import StorageWithExpiry from '../utilities/storageWithExpiry.js';

const TWO_WEEKS = 1000 * 60 * 60 * 24 * 14;

function dismiss(dialog) {
    StorageWithExpiry.set('newsletterDismissed', true, TWO_WEEKS);
    dialog.close()
    document.body.classList.remove('newsletter-dialog--open')
}

function setup(dialog) {
    const container = dialog.querySelector('.newsletter-dialog__container')
    const form = dialog.querySelector('form')

    if (!dialog.dataset.delay || StorageWithExpiry.get('newsletterDismissed')) {
        return
    }

    const delay = dialog.dataset.delay * 1000

    setTimeout(() => {
        dialog.showModal()
        document.body.classList.add('newsletter-dialog--open')
    }, delay)

    // Pressing Escape
    dialog.addEventListener('cancel', () => {
        dismiss(dialog)
    })

    document.addEventListener('click', (event) => {
        if (!container.contains(event.target)) {
            // Clicking outside modal
            dismiss(dialog)
        } else {

            // Clicking close button
            if (event.target.classList.contains('close')) {
                dismiss(dialog)
            }
        }
    });

    form.addEventListener('success', () => {
        setTimeout(() => {
            dismiss(dialog)
        }, 1000)
    })

    form.addEventListener('fail', () => {
        dismiss(dialog)
    })
}

function main() {
    const dialog = document.querySelector('.newsletter-dialog')

    if(!dialog) return

    setup(dialog)
}

main()
